<template>
    <v-layout class="app-content login-page">
        <v-flex>
            <v-layout class="form-layout"
                      wrap
                      pa-12
                      align-center>
                <v-card class="pa-4 login-card" style="width: 400px; border-radius: 10px;">
                    <h1 class="mb-6 text--default_primary_color">Escritório Digital - Vendas</h1>
                    <m-form ref="form"
                            class="card"
                            @submit.prevent="enviar">
                        <v-row class="align-md-center align-content-lg-space-between flex-container">
                            <v-col cols="10">
                                <v-switch v-model="loginMode" class="mb-2" color="default_primary_color" :true-value="LoginComum" :false-value="LoginCpfCnpj"
                                          :label="loginMode === LoginComum ? 'Código do Usuário' : 'CPF/CNPJ'"></v-switch>
                            </v-col>
                            <v-col cols="2" class="mb-7">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" color="default_primary_color">mdi-help-circle-outline</v-icon>
                                    </template>
                                    <span v-if="loginMode === LoginComum">Ao clicar no botão ao lado a forma de login será alterada para entrar com CPF/CNPJ.</span>
                                    <span v-else>Ao clicar no botão ao lado a forma de login será alterada para entrar com Código do Usuário.</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                        <m-text-field
                                v-if="loginMode === LoginComum"
                                autocomplete="off"
                                hint="Não é necessário colocar pontos e traços!"
                                solo
                                placeholder="Informe o Código do Usuário."
                                v-model="login"
                                :rules="[$rules.required]"
                                prepend-inner-icon="ol-perm_identity"
                                :maxlength="10">
                            <v-icon slot="prepend-inner"
                                    color="default_accent_color">
                                ol-perm_identity
                            </v-icon>
                        </m-text-field>
                        <v-text-field
                                v-else-if="loginMode === LoginCpfCnpj"
                                autocomplete="off"
                                hint="Não é necessário colocar pontos e traços!"
                                placeholder="Informe o CPF/CNPJ."
                                solo
                                validate-on-blur
                                v-model="documentIdentification"
                                :rules="[$rules.required,$rules.cpf_cnpj]"
                                v-mask="['###.###.###-##','##.###.###/####-##']"
                                :maxlength="20">
                            <v-icon slot="prepend-inner"
                                    color="default_accent_color">
                                ol-perm_identity
                            </v-icon>
                        </v-text-field>
                        <m-text-field placeholder="Informe a Senha."
                                      :type="pass_visible ? 'text' : 'password'"
                                      solo
                                      v-model="senha"
                                      :rules="[$rules.required]"
                                      maxlength="50">
                            <v-icon slot="append"
                                    @click="pass_visible = !pass_visible"
                                    :color="pass_visible ? 'default_primary_color' : 'darkgray'">
                                ol-visibility
                            </v-icon>
                            <v-icon slot="prepend-inner"
                                    color="default_accent_color">
                                ol-lock
                            </v-icon>
                        </m-text-field>
                        <v-flex class="forgot-password">
                            <span class="link-text" @click="openModal">Esqueci minha senha</span>
                        </v-flex>
                        <v-flex offset-xs6>
                            <v-btn class="btn-default default_primary_color" style="color:#fff" type="submit">
                                Entrar
                            </v-btn>
                        </v-flex>
                    </m-form>
                </v-card>
                <div class="footer-content">
                    <h3 class="grey--text">Desenvolvido por:</h3>
                    <div class="footer-image">
                        <v-img src="../assets/img/logo_stefanini_blanco.png" contain max-height="80px"></v-img>
                    </div>
                </div>
            </v-layout>
        </v-flex>
        <DialogForgotPasword v-model="modalForgotPassword" />
        <DialogCommercialHierarchyLogin v-model="dialogCommercialHierarchyVisible" :items="commercialHierarchyData" />
        <DialogCommercialHierarchyAssistentLogin v-model="dialogAssistentCommercialHierarchyVisible" :items="commercialHierarchyAssistentData" @validateHierarchyReturn="validateHierarchyReturn" />
    </v-layout>
</template>

<script>
  import { sleep, decrypt, unmask, alert, notification, findUnidadeMultiplasEmpresas } from '../plugins/helpers'
  import { autenticar } from '../webservice/autenticar'
  import { isEmpty } from 'lodash'
  import { origensAcesso, LoginComum, LoginCpfCnpj } from '@/plugins/constants'
  import DialogForgotPasword from '@/dialogs/DialogForgotPasword'
  import DialogCommercialHierarchyLogin from '@/components/hierarquia-comercial/DialogCommercialHierarchyLogin.vue'
  import commercialHierarchy from '@/mixins/commercialHierarchy'
  import DialogCommercialHierarchyAssistentLogin from '@/components/hierarquia-comercial/DialogCommercialHierarchyAssistentLogin.vue'
  import { AlertTypes } from '../plugins/alerts_types'
  import { mensagemUsuarioBloqueado } from '../enums/usuario_bloqueado/mensagemUsuarioBloqueado'

  export default {
    name: 'Login',
    components: { DialogForgotPasword, DialogCommercialHierarchyLogin, DialogCommercialHierarchyAssistentLogin },
    mixins: [commercialHierarchy],
    data: () => ({
      pass_visible: false,
      login: '',
      senha: '',
      LoginComum,
      LoginCpfCnpj,
      loginMode: LoginCpfCnpj,
      modalForgotPassword: false,
      esqueciSenha: '',
      documentIdentification: ''
    }),
    computed: {
      showModalForgotPassword () {
        return this.modalForgotPassword
      }
    },
    watch: {
      loginMode (newMode) {
        if (newMode === LoginComum) {
          this.resetCpfCnpjField()
        } else if (newMode === LoginCpfCnpj) {
          this.resetNormalField()
        }
      }
    },
    async mounted () {
      if (typeof this.$route.params.login !== 'undefined' && !isEmpty(this.$route.params.login)) {
        this.loginMode = LoginComum
        this.login = this.$route.params.login
        this.senha = decrypt(this.login, this.$route.params.senha, origensAcesso.login_painel)
        this.enviar()
      }
    },
    methods: {
      resetCpfCnpjField () {
        this.documentIdentification = ''
      },
      resetNormalField () {
        this.login = ''
      },
      handleErrorToGetLogin () {
        notification('warning', 'Caro parceiro, não foi encontrada nenhuma forma de login cadastrada na plataforma, sugerimos tentar novamente e caso o erro persista, entre em contato com a Área de Suporte.')
      },
      handleLoginErrorInitial () {
        notification('error', 'Caro parceiro, não foi possível autenticar seu login, tente novamente e caso o erro persista entre em contato com a Área de Suporte.')
      },
      handleLoginError () {
        notification('error', 'Acesso não permitido, por favor utilize o link de acesso externo a partir do escritório digital.')
      },
      async loginSistema (login, isUsuarioBackOffice = false) {
        try {
          const origemAcesso = this.$route.params.origem_painel ? origensAcesso.login_painel : origensAcesso.login_e_senha
          const isToSavePass = !!this.$route.params.origem_painel
          autenticar(login, this.senha, isToSavePass, true)
            .then((response) => {
              this.$session.set('origem_acesso', origemAcesso)

              if (this.validateHierarchyReturn(response)) {
                return
              }

              if (isUsuarioBackOffice) {
                this.redirecionarFluxoBackOffice()
              } else {
                this.redirecionarFluxoEscolherAmbientes(response)
              }
            })
            .catch(err => {
              this.$session.destroy()
              if (err?.response?.data?.Msg_Erro) {
                let msgErroCompleta = err.response.data.Msg_Erro
                if (err.response.data.senha_invalida) {
                  msgErroCompleta += '<br><strong>Atenção:</strong> A senha de acesso da Plataforma de Vendas não é a mesma do Escritório Digital.'
                }
                notification('error', msgErroCompleta, 'Não foi possível autenticar.', true)
              } else {
                notification('error', 'Não foi possível autenticar.')
              }
            })
        } catch (err) {
          this.handleLoginError()
        }
      },
      redirecionarFluxoBackOffice () {
        this.$router.replace('/')
      },
      async redirecionarFluxoEscolherAmbientes (res) {
        const ambientesPorUsuario = await this.$http.post('/ambientes-por-usuario', {
          data: res.data,
          empresas: res.data.Empresas
        }).then(ambientesPermitidosRequest => {
          return ambientesPermitidosRequest.data
        }).catch((e) => {
          this.handleLoginErrorInitial()
          throw e
        })
        const empresas = res.data.Empresas.Empresa
        const unidades = res.data.UnidadesNegocio
        const id_empresa = this.$session.get('id_empresa')
        const id_unidade = this.$session.get('id_unidade_negocio')

        const ids_empresas_permitidas_usuario = empresas.map(empresa => empresa.ID_Empresa)
        const ids_empresas_permitidas_ambiente = ambientesPorUsuario.empresas_permitidas.map(empresa => empresa.ID_Empresa)

        if (empresas) {
          this.$session.set('id_empresa', id_empresa)
          this.$session.set('empresas', empresas)

          const filial = res.data['FiliaisVenda']['FilialVenda'].find(filial => filial.ID_Empresa === id_empresa)

          if (filial) {
            this.$session.set('filial', filial)
          }
        } else {
          alert(`A empresa ${id_empresa} é inválida. Consulte a administradora`)
          return
        }

        const unidade = findUnidadeMultiplasEmpresas(id_unidade, unidades, ids_empresas_permitidas_usuario, this.$session.get('vendas_backoffice'))
        if (unidade) {
          this.$session.set('id_unidade_negocio', id_unidade)
          this.$session.set('unidades', [unidade])
        } else {
          alert(`A Unidade de Negócio ${id_unidade} é inválida. Consulte a administradora`)
          return
        }
        this.$session.set('identificador_representante_tribanco', null)
        this.$session.set('ids_empresas_permitidas', ids_empresas_permitidas_ambiente)
        this.$session.set('unidade_exclusiva', ambientesPorUsuario.unidade_negocio_exclusiva)
        this.$router.replace('/escolher_ambiente')
      },
      openModal () {
        this.modalForgotPassword = true
      },
      closeModal () {
        this.modalForgotPassword = false
      },
      async enviar () {
        this.$session.destroy()
        const form = this.$refs.form
        if (form.validate() || this.$route.params.origem_painel) {
          let login = null
          if (this.loginMode === LoginCpfCnpj) {
            login = await this.buscarLoginUsuarioPorDocumento(this.documentIdentification)
          } else if (this.loginMode === LoginComum) {
            login = this.login
          }
          this.$store.commit('setAdditionalLoadingText', 'Autenticando! Por favor, aguarde.')
          this.autenticarUsuario(login)
        } else {
          form.resetValidation()
          sleep(100).then(() => form.validate())
        }
      },
      async autenticarUsuario (login) {
        try {
          const response = await this.$http.get(`/usuario/backoffice/${login}`, {
            options: { showAdditionalLoadingText: true }
          })

          const isUsuarioBackOffice = response.data.permite_venda_backoffice
          const isBlocked = response.data.is_blocked

          if (isBlocked) {
            notification(AlertTypes.ERROR, mensagemUsuarioBloqueado.USER_BLOCKED, 'Usuário Bloqueado')
            return
          }

          this.loginSistema(login, isUsuarioBackOffice)
        } catch (e) {
          this.handleLoginErrorInitial()
          throw e
        }
      },
      async buscarLoginUsuarioPorDocumento (documentIdentification) {
        const loginCpf = unmask(documentIdentification)
        let loginUsuario = await this.$http.get(`/usuario/backoffice/cpfCnpj/${loginCpf}`)
          .then(response => response.data.login)
          .catch((e) => {
            this.handleErrorToGetLogin()
            throw e
          })
        return loginUsuario
      }
    }
  }
</script>

<style scoped lang="scss">
    .app-content {
        background-image: url(../assets/img/painel-bg.jpg) !important;
    }
    form {
        width: 100%;
    }
    .form-layout {
        max-width: 500px;
        height: 100%;
        margin: auto;
    }
    .link-text {
      cursor: pointer;
      text-decoration: none;
      border-bottom: 1px solid rgb(0, 0, 0);
    }
    .forgot-password {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 10px;
    }
    .toggleText {
      text-align: center;
      margin-top: 5px;
      color: #333;
    }
    .flex-container {
    display: flex;
    align-items: center;
    }
    .footer-content {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 10px;
    display: block;
    align-items: flex-start;
    width: auto;
    max-width: 160px;
    padding: 2px;
    }
    .footer-image img {
    width: 100%;
    max-height: 100px;
    object-fit: contain;
    }
</style>
